module.exports = __webpack_public_path__ + "static/media/torchIcon.f49afc13.svg";